'use client';

import React, { ComponentProps, ElementType, Fragment, useState } from 'react';

import { SsiInclude } from '@bytel/react-ssi-include';

import { getAppConfig } from '@services/config';

const appConfig = getAppConfig();

/** En développement, les partials sont servis par un autre domaine que l'app. */
function resolveSrc(url: string): string {
    return process.env.NODE_ENV === 'development' ? appConfig.assets.partials.url + url.replace('/partials', '') : url;
}

interface SSIBlockProps<T extends ElementType = typeof Fragment> {
    url: string;
    container?: T;
    containerProps?: Omit<ComponentProps<T>, 'children'>;
}

/**
 * Return an SSI block
 * @param url Partial URL (/partials/xxxx)
 * @param container Wrapper for the SSI block
 * @returns
 */
export function SSIBlock<T extends ElementType = typeof Fragment>({
    url,
    // @ts-expect-error - We don't care about the children prop
    container: Container = 'div',
    containerProps,
}: Readonly<SSIBlockProps<T>>) {
    // Le conteneur apporte son propre habillage (titre de FAQ, accordéon de
    // mentions légales) : en cas d'échec, c'est tout le bloc qui disparaît, pas
    // seulement le contenu du partial.
    const [failedUrl, setFailedUrl] = useState<string | null>(null);

    if (failedUrl === url) {
        return null;
    }

    return (
        // @ts-expect-error - We don't care about the children prop
        <Container {...containerProps}>
            <SsiInclude src={resolveSrc(url)} data-testid='block-cms' onError={() => setFailedUrl(url)} />
        </Container>
    );
}
